import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { SettingsContext } from "../SettingsContext";

function Footer() {
  const { settings } = useContext(SettingsContext);

  return (
    <>
      {/* Footer Section */}
      <footer className="footer px-sm-5 row">
        {/* Company Info */}
        <div className="col-lg-3 col-sm-6 mb-3">
          <Link className="navbar-brand order-1" to="/">
            <img src='/assets/img/logo.png' alt="Logo" height="70" />
          </Link>

          <p className="mt-3">Welcome to Color Kingdon - where imagination comes alive! Our premium colouring books spark creativity, 
              relieve stress, and bring joy to kids and adults. Hand-drawn designs, thick bleed-proof paper, 
              and themes for every passion. Made with love in India.</p>

          <div className="social-icons ">
            <Link
              to={`https://wa.me/${settings?.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp mt-2 "></i>
            </Link>
            <Link to={`${settings?.facebook}`}>
              <i className="fab fa-facebook-f mt-2"></i>
            </Link>
            <Link to={`${settings?.instagram}`}>
              <i className="fab fa-instagram mt-2"></i>
            </Link>
            <Link to={`${settings?.youtube}`}>
              <i className="fab fa-youtube mt-2"></i>
            </Link>
            <Link to={`${settings?.twitter}`}>
              <i className="fab fa-twitter mt-2"></i>
            </Link>
          </div>
        </div>

        {/* Contact Info */}
        <div className="col-lg-3 col-sm-6 mb-3">
          <h5 className="footer-title">
            <b>Contacts</b>
          </h5>
          <p>
            <span>
              <i className="fa-solid fa-location-dot pe-2 text-success"></i>
            </span>
            {settings?.address}
          </p>
          <p>
            <span>
              <i className="fa-solid fa-phone pe-2 text-success"></i>
            </span>
            <Link to={`tel:${settings?.contact}`}>
              {settings?.contact}
              <br />
            </Link>
          </p>
          <p>
            <span>
              <i className="fa-solid fa-phone pe-2 text-success"></i>
            </span>
            <Link to={`tel:${settings?.mobile}`}>
              {settings?.mobile}
              <br />
            </Link>
          </p>
          <p>
            <span>
              <i className="fa-solid fa-envelope pe-2 text-success"></i>
            </span>{" "}
            <Link to={`mailto:${settings?.email}`}>{settings?.email}</Link>
          </p>
        </div>

        {/* Services */}
        <div className="col-lg-2 col-sm-6 mb-3">
          <h5 className="footer-title">
            <b>Services</b>
          </h5>
          <ul className="list-unstyled">
            <li>
              <Link to="/our-story">About Us</Link>
            </li>
            <li>
              <Link to="/reviewus">Rate Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <Link to="/blog">Our Blogs</Link>
            </li>
            <li>
              <Link to="/desi-cow-ghee">Products</Link>
            </li>
          </ul>
        </div>

        {/* Privacy & Terms */}
        <div className="col-lg-2 col-sm-6 mb-3">
          <h5 className="footer-title">
            <b>Privacy & Terms</b>
          </h5>
          <ul className="list-unstyled">
            <li>
              <Link to="/our-policies">Payment Policy</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/return-policy">Return Policy</Link>
            </li>
            <li>
              <Link to="/shipping-policy">Shipping Policy</Link>
            </li>
            <li>
              <Link to="/terms-conditions">Terms & Conditions</Link>
            </li>
          </ul>
        </div>

        {/* My Account */}
        <div className="col-lg-2 col-sm-6 mb-3">
          <h5 className="footer-title">
            <b>My Account</b>
          </h5>
          <ul className="list-unstyled">
            <li>
              <Link to="/login">My Account</Link>
            </li>
            <li>
              <Link to="/cart">My Cart</Link>
            </li>
            <li>
              <Link to="/login">Order History</Link>
            </li>
            <li>
              <Link to="/cart">My Wishlist</Link>
            </li>
            <li>
              <Link to="/track-order">Track Order</Link>
            </li>
          </ul>
        </div>
      </footer>

      {/* Footer Bottom */}
      <div className="footer-bottom row px-sm-5">
        <p className="pt-1">
          © {new Date().getFullYear()} All Copyrights Reserved By Color Kingdon
        </p>
      </div>

      {/* Floating WhatsApp Button */}
      <Link
        to={`https://wa.me/${settings?.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <i className="fab fa-whatsapp"></i>
      </Link>
    </>
  );
}

export default Footer;
